import SmartErrorScreen from '@/src/auth/smartErrorScreen';

export default SmartErrorScreen;
